/** What a build no deploy stamped reports: `npm start`, or `dotnet run` on the API's side. */
export const DEVELOPMENT_COMMIT = "dev";

const SHORT_LENGTH = 10;
const FULL_SHA = /^[0-9a-f]{40}$/i;
const COMMIT_URL = "https://github.com/IP-Attorney-Hub/ipah/commit/";

/**
 * The git commit a deployed side was built from. The frontend's comes from `VITE_COMMIT_SHA`,
 * which `.github/actions/build-frontend-bundle` sets from the checkout it builds; the API's from
 * `GET super-user/version`, which reads the `COMMIT_SHA` the deploy wrote into its image.
 *
 * The two sides deploy independently, so they can name different commits. Unlike the CI run
 * numbers this replaces, commits have no order, and neither is "the" version: both are shown.
 */
export class DeploymentCommit {
  readonly sha: string;

  /** The first ten characters of a full SHA, as GitHub abbreviates one; anything else as it is. */
  get short(): string {
    return this.isFullSha ? this.sha.slice(0, SHORT_LENGTH) : this.sha;
  }

  /** The commit on GitHub, when this names one. */
  get url(): string | undefined {
    return this.isFullSha ? `${COMMIT_URL}${this.sha}` : undefined;
  }

  constructor(sha?: string) {
    this.sha = sha?.trim() || DEVELOPMENT_COMMIT;
  }

  isEqualTo(other: DeploymentCommit): boolean {
    return this.sha.toLowerCase() === other.sha.toLowerCase();
  }

  private get isFullSha(): boolean {
    return FULL_SHA.test(this.sha);
  }
}
